import { Model } from 'vue-mc';

export default class ShoppingCart extends Model {
  defaults() {
    return {
      id: null,
      items: [],
      summary: {
        currency: null,
        currency_name: null,
        tax_name: null,
        sub_total: 0,
        tax: 0,
        total: 0,
        extra_discount: 0,
        total_order: 0,
        currency_payment: null,
        currency_total: 0
      },
      message: "",
      messages: [
        '',
        'Agrege otra articulo para obtener -30% de descuento. Debe de ser el mismo tipo de producto',
        'Agrege otra articulo para obtener -30% -30% de descuento. Debe de ser el mismo tipo de producto',
        'Agrege otra articulo para obtener -30% -30% -20% de descuento. Debe de ser el mismo tipo de producto'
      ],
      cookieName: "ChuspicToken"
    }
  }

  token() {
    const value = `; ${document.cookie}`,
        parts = value.split(`; ${this.cookieName}=`);
    return parts.pop().split(';').shift();
  }

  totalItems() {
    return this.items.length
  }

  empty() {
    return this.totalItems() == 0
  }

  total() {
    return this.summary.total
  }

  hasTax() {
    return this.summary.tax > 0
  }

  hasExtraDiscount() {
    return this.summary.extra_discount > 0
  }

  itemDiscounts(item) {
    return item.discounts.split(",").map(i => { return `- ${i}%`})
  }

  applyDiscounts() {
    let index = 0
    this.message = ""

    for(var i in this.items) {
      let item = this.items[i];
      if(item.photo_id != null) {
        index = (index >= 3) ? 3 : index + 1;
      }
    }
    this.message = this.messages[index]
  }

  hasMessage() {
    return this.message.length > 0
  }

  async fetch() {
    let request = await this.createRequest({
      method: 'GET',
      url: `/api/v2/shopping_cart?token=${this.token()}`
    }).send()

    if(request.response.data.shopping_cart) {
      return request.response.data.shopping_cart
    }
    return []
  }

  async addItem(params) {
    let response = await this.createRequest({
      method: 'POST',
      url: `/api/v2/shopping_cart/add_item?token=${this.token()}`,
      params: params
    }).send()
    return response
  }

  async removeItem(id) {
    let response = await this.createRequest({
      method: 'POST',
      url: `/api/v2/shopping_cart/${id}/remove_item?token=${this.token()}`
    }).send()
    return response
  }
}
